// Lenguaje visual común de la suite Dimo (azul corporativo Grupo Dimoauto,
// Plus Jakarta Sans). Tokens alineados con el ecosistema de apps del grupo:
// azul principal #005187, azul claro #1a9cd4, azul profundo #003258.
export const C = {
  brand: "#005187",
  brandDark: "#003258",
  ink: "#1f2a37",
  page: "#2b333d",
  muted: "#8a929c",
  faint: "#9aa4af",
  line: "#e7e9ec",
  bg: "#f4f5f7",
  card: "#ffffff",
  verde: "#2e9e5b",
  naranja: "#e08c1e",
  rojo: "#d23b34",
  gris: "#b6bcc4",
  morado: "#7a5bd0",
};

// Motores de IA del sondeo GEO: color de marca y nombre corto. Se usan en el
// desglose por motor del Dashboard, donde el agregado (6 %) esconde que Claude
// nos menciona y Gemini no.
export const MOTOR_COLOR = {
  claude: "#d97757", gemini: "#4285f4", perplexity: "#20808d",
  openai: "#10a37f", bing: "#0078d4", google_aio: "#ea4335",
};
export const MOTOR_LABEL = {
  claude: "Claude", gemini: "Gemini", perplexity: "Perplexity",
  openai: "OpenAI", bing: "Bing", google_aio: "Google AIO",
};
// Orden estable en la interfaz (el de `geo_results` depende de la ingesta).
export const MOTOR_ORDEN = ["claude", "gemini", "perplexity", "openai", "bing", "google_aio"];
// Logo real de cada motor para el hueco del rosco (solo el símbolo, sin
// wordmark). Compartido por Dashboard y Visibilidad IA.
export const MOTOR_LOGO = {
  claude: "/img/logos/claude.png",
  gemini: "/img/logos/gemini.png",
  bing: "/img/logos/bing.png",
  openai: "/img/logos/openai.png",
};

// Meses cortos en castellano.
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

export function fmtFecha(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return `${String(d.getDate()).padStart(2, "0")} ${MES[d.getMonth()]}`;
}

export function fmtNum(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(n);
}

export function fmtPct(n, dec = 0) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: dec }).format(n) + " %";
}

export function fmtEuro(n, dec = 2) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: dec, minimumFractionDigits: dec }).format(n);
}

// Gradiente de marca para acentos premium (nav activa, hero, chips de icono).
export const GRAD = "linear-gradient(135deg, #005187 0%, #1a9cd4 100%)";
export const GRAD_DEEP = "linear-gradient(130deg, #003258 0%, #005187 55%, #1a9cd4 100%)";

export function fmtPos(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 1 }).format(n);
}

// Semáforo por Core Web Vital (umbrales oficiales de Google).
export function cwvColor(metric, value) {
  if (value == null || isNaN(value)) return C.gris;
  if (metric === "lcp") return value <= 2.5 ? C.verde : value <= 4 ? C.naranja : C.rojo;   // segundos
  if (metric === "inp") return value <= 200 ? C.verde : value <= 500 ? C.naranja : C.rojo; // ms
  if (metric === "cls") return value <= 0.1 ? C.verde : value <= 0.25 ? C.naranja : C.rojo;
  if (metric === "score") return value >= 90 ? C.verde : value >= 50 ? C.naranja : C.rojo; // 0..100
  return C.gris;
}

export function posColor(pos) {
  if (pos == null || isNaN(pos)) return C.gris;
  if (pos <= 3) return C.verde;
  if (pos <= 10) return C.brand;
  if (pos <= 20) return C.naranja;
  return C.rojo;
}

export function sentimientoColor(s) {
  if (s === "positivo") return C.verde;
  if (s === "negativo") return C.rojo;
  return C.muted;
}
